<template>
  <div class="slider" :class="{ 'slider--app' : $inApp }">
    <div class="slider__container" @click="startPlaying">
      <div class="slider__item" v-for="slide in characters" :key="slide.id" :data-id="slide.id">
        <img :src="slide.img" :alt="slide.name">
      </div>
    </div>

    <div class="slider__arrow slider__arrow--left" @click="() => slider.animate(isTouchDevice ? 1 : -1)">
      <img src="/img/characters/arrow-left.png" alt="arrow left">
    </div>

    <div class="slider__arrow slider__arrow--right" @click="() => slider.animate(isTouchDevice ? -1 : 1)">
      <img src="/img/characters/arrow-right.png" alt="arrow left">
    </div>

    <div class="slider__name">
      <img class="name__bg" src="/img/characters/ribbon.png" alt="Ribbon name character">

      <svg class="name__text" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 107.1 32.1">
        <transition @enter="enterText" @leave="leaveText" appear>
          <g id="anjelica" v-if="slider && characters[slider.currentIndex].id === 'anjelica'" :key="slider.currentIndex">
            <path d="M3,19.7l0.2-1.1c1.7,0,2.3-0.6,3.6-2.5l6.5-10.3c0.2-0.2,0.3-0.5,0.4-0.8c0-0.1,0-0.3,0-0.5V4.5
              C13.8,4.2,14,4,14.2,3.8L15,2.8c0.4-0.5,0.6-0.6,1.1-0.5c0.5,0.1,0.6,0.3,0.7,0.9l3.4,16.1c0.1,1.3,1.1,2.3,2.4,2.4l-0.2,1.1
              l-8.8-1.5l0.2-1.2c1.8,0.3,2.3,0.1,2.4-0.4c0-0.4,0-0.9-0.1-1.3l-0.7-3.8l-5.7-0.9l-1.1,1.8c-0.5,0.7-0.9,1.5-1.2,2.4
              c-0.2,0.9,0.2,1.2,1.6,1.5l-0.2,1.1L3,19.7z M15.2,13.6L14,7.2h-0.2l-3.4,5.6L15.2,13.6z"/>
            <path d="M25.5,23.2l0.1-1c1.2,0.1,1.6-0.1,1.8-1.5l0.5-5.8c0.1-1.5-0.2-1.8-0.9-2c-0.2-0.1-0.3-0.1-0.3-0.4
              c0-0.2,0.1-0.4,0.4-0.4c0,0,0,0,0,0c1-0.2,3.6-1.2,3.8-1.2s0.3,0.2,0.3,0.7L31,13c1.1-0.8,2.5-1.2,3.9-1.1c2.5,0.2,3.9,1.6,3.6,4.8
              L38,21.8c-0.1,1.4,0.4,1.7,1.5,1.8l-0.1,1L33.2,24l0.1-1c1.2,0,1.6-0.3,1.7-1.3l0.4-4.7c0.2-2.8-0.4-3.5-1.9-3.7
              c-1-0.1-1.9,0.3-2.6,0.9l-0.6,7c-0.1,1.3,0.2,1.6,1.3,1.7l-0.1,1L25.5,23.2z"/>
            <path d="M40.4,30.6c2.5-1.3,3-2.5,3.2-6.7l0.3-7.1c0.1-1.9-0.3-2.6-1.8-2.6c-0.3,0-0.3-0.1-0.3-0.5s0.1-0.4,0.3-0.5
              c0.9-0.1,4-0.9,4.6-0.9c0.2,0,0.5,0.1,0.5,1.3l-0.4,9.7c-0.2,4.2-1.2,6.7-6.2,8.2L40.4,30.6z M43.9,7.4c0-1,0.9-1.7,1.8-1.7
              c1,0,1.7,0.9,1.7,1.8c0,1-0.9,1.7-1.8,1.7C44.6,9.2,43.9,8.4,43.9,7.4C43.9,7.4,43.9,7.4,43.9,7.4z"/>
            <path d="M53.8,17.4c0,3.1,0.8,6,3.6,6c1.1,0,2.2-0.4,3.1-1.2l0.5,0.6c-1.2,1.4-2.9,2.2-4.7,2.3c-3.5,0-5.7-2.2-5.8-6
              c0-3.4,2.5-6.4,5.6-6.4c2.6,0,4.7,2,4.8,4.6c0,0,0,0,0,0L53.8,17.4z M58,16.2c0-1.6-0.8-2.6-2-2.6c-1.4,0-2.1,1.2-2.2,2.6L58,16.2z
              "/>
            <path d="M63.2,23.7c1.5-0.1,1.8-0.4,1.7-2.1L64,8.1c-0.1-1.3-0.3-1.6-1.2-1.8c-0.2,0-0.3-0.2-0.3-0.4s0-0.4,0.2-0.4
              c1.2-0.5,2.4-1,3.7-1.3c0.3,0,0.4,0.1,0.5,1.1l1,16.2c0.1,1.7,0.4,2,1.9,1.9v1l-6.6,0.4L63.2,23.7z"/>
            <path d="M71.8,24.1l-0.1-1c1.4-0.1,1.8-0.5,1.6-1.8l-0.6-5.8c-0.1-1.3-0.4-1.6-1.4-1.7c-0.1,0-0.2-0.2-0.2-0.4
              s0-0.4,0.3-0.5c1.1-0.5,2.3-1,3.5-1.4c0.3,0,0.5,0.1,0.6,1.1l0.9,8.5c0.1,1.3,0.5,1.5,2,1.3l0.1,1L71.8,24.1z M71.5,6.8
              c-0.1-1,0.6-1.8,1.6-1.9c1-0.1,1.8,0.6,1.9,1.6s-0.6,1.8-1.6,1.9c0,0,0,0,0,0C72.5,8.5,71.7,7.8,71.5,6.8
              C71.5,6.9,71.5,6.8,71.5,6.8z"/>
            <path d="M90.6,19.3c-1,1.6-2.6,2.8-4.5,3.2c-3.7,0.6-5.7-2.2-6.1-4.6c-0.7-3.6,1.6-7.1,5.1-7.9
              c1.8-0.3,3.5,0.3,3.7,1.6c0.1,0.5-0.2,1-0.6,1.1c0,0-0.1,0-0.1,0c-1.5,0.2-2.3-1.7-3.7-1.5s-2,1.7-1.6,4.5s2,4.9,4.1,4.5
              c1.1-0.2,2.1-0.9,2.7-1.8L90.6,19.3z"/>
            <path d="M97.7,10.7c-0.4-1.7-1.1-2.1-2-1.8c-2.5,0.6-1.2,4.3-2.9,4.8c-0.6,0.1-1.1-0.2-1.3-0.9c-0.4-1.6,1.9-4.3,4.6-5
              c3-0.8,4,0.5,4.6,2.7s1.1,4.9,1.3,5.7c0.3,1.2,0.5,1.4,0.8,1.3s0.4-0.3,0.5-0.6l0.7,0.5c-0.4,0.8-1,1.4-1.9,1.6
              c-1,0.3-2-0.1-2.6-0.9c-0.7,1.3-1.9,2.2-3.4,2.5c-2.1,0.5-3.2-0.4-3.5-1.5c-0.8-3.1,4.2-5.2,5.6-5.8L97.7,10.7z M97.5,18.8
              c1.6-0.4,1.7-2,1.1-4.7c-1.1,0.4-3.3,1.5-2.8,3.5c0.1,0.8,0.8,1.3,1.5,1.2C97.4,18.8,97.5,18.8,97.5,18.8z"/>
          </g>
          <g id="florence" v-if="slider && characters[slider.currentIndex].id === 'florence'" :key="slider.currentIndex">
            <path d="M1.6,19.2l0.2-1.1c2,0.4,2.6-0.1,2.9-1.7L6.9,4.2c0.3-1.6-0.2-2.3-2.2-2.6L5,0.5l14.8,2.7l0.4,3
              c0.1,0.4,0.1,0.8,0.1,1.3c-0.1,0.3-0.4,0.4-0.7,0.4c-0.3,0-0.5-0.5-0.8-1.1c-1.3-2.6-1.6-2.9-4.5-3.4c-2.7-0.5-3.2-0.2-3.4,1
              l-1,5.7l3.5,0.6c1.2,0.4,2.4-0.3,2.8-1.4c0,0,0,0,0,0c0.3-0.6,0.4-0.7,0.7-0.6c0.3,0.1,0.5,0.2,0.5,0.4l-1.1,6.2
              c0,0.2-0.2,0.3-0.6,0.3s-0.3-0.2-0.4-0.8c-0.2-1.9-0.8-2.4-3.3-2.9l-2.3-0.4l-1,5.8c-0.3,1.7,0.3,2.2,2.8,2.6l-0.2,1.1L1.6,19.2z"
              />
            <path d="M19.7,21.3c1.5,0.2,1.8-0.1,2-1.8l1.7-13.4c0.2-1.3,0-1.6-0.9-2c-0.2-0.1-0.3-0.2-0.2-0.5s0.1-0.3,0.3-0.4
              C24,3,25.3,2.8,26.6,2.7c0.3,0,0.4,0.2,0.3,1.1l-2.1,16.1c-0.2,1.7,0,2,1.5,2.3l-0.1,1l-6.6-0.9L19.7,21.3z"/>
            <path d="M34.2,24.1c-3.3-0.3-5.8-3.2-5.5-6.5c0-0.1,0-0.1,0-0.2c0.3-3.3,3.2-5.8,6.5-5.5s5.8,3.2,5.5,6.5
              c-0.2,3.3-3,5.8-6.3,5.7C34.3,24.1,34.2,24.1,34.2,24.1z M35.2,12.7c-1.6-0.1-2.8,1.8-3,5c-0.3,3.2,0.5,5.3,2.2,5.5s2.8-1.8,3-5
              S36.7,12.8,35.2,12.7L35.2,12.7z"/>
            <path d="M42.5,24.5v-1c1.4,0,1.9-0.2,1.9-1.6l0.2-5.7c0-1.3-0.2-1.6-1.2-1.9c-0.1,0-0.2-0.2-0.2-0.4s0.1-0.4,0.3-0.4
              c1.2-0.4,2.4-0.7,3.7-0.9c0.3,0,0.5,0.2,0.5,1.1v1.1h0.1c1-1.2,2-2.2,3.3-2.1c0.8,0,1.6,0.5,1.5,1.3c0,0.7-0.6,1.4-1.3,1.4
              c-0.1,0-0.2,0-0.3,0c-0.9,0-1.6-0.3-2.1-0.3c-1,0-1.3,0.6-1.4,1.8l-0.2,5.3c0,1.3,0.3,1.5,1.7,1.6v1L42.5,24.5z"/>
            <path d="M57,17.3c0,3.1,0.8,6,3.7,6c1.1,0,2.2-0.4,3.1-1.2l0.5,0.6c-1.2,1.4-2.8,2.2-4.6,2.3c-3.5,0.1-5.8-2.1-5.8-6
              c-0.1-3.4,2.4-6.4,5.5-6.5c2.6-0.1,4.8,1.9,4.9,4.5c0,0,0,0,0,0.1L57,17.3z M61.1,16c0-1.6-0.8-2.6-2-2.5c-1.4,0-2,1.3-2.2,2.6
              L61.1,16z"/>
            <path d="M66.9,24.5l-0.1-1c1.2-0.1,1.6-0.4,1.4-1.8L67.7,16c-0.1-1.5-0.5-1.8-1.3-1.8c-0.2,0-0.3,0-0.4-0.3
              c0-0.2,0.1-0.4,0.3-0.5c1-0.4,3.3-1.9,3.6-1.9s0.4,0.1,0.4,0.7l0.1,1.4c1-1,2.2-1.6,3.6-1.9c2.5-0.2,4.1,0.8,4.4,4.1l0.5,5.1
              c0.1,1.3,0.7,1.6,1.8,1.5l0.1,1l-6.2,0.5l-0.1-1c1.2-0.2,1.6-0.6,1.5-1.6l-0.4-4.7c-0.3-2.8-1-3.4-2.6-3.2c-1,0.1-1.9,0.6-2.4,1.4
              l0.7,7c0.1,1.3,0.5,1.5,1.6,1.4l0.1,1L66.9,24.5z"/>
            <path d="M93.1,18.7c-0.9,1.7-2.5,2.9-4.4,3.3c-3.7,0.7-5.7-2.2-6.1-4.5c-0.8-3.6,1.4-7.1,5-7.9
              c1.8-0.3,3.5,0.3,3.7,1.6c0.1,0.5-0.1,1-0.6,1.1c0,0-0.1,0-0.1,0c-1.5,0.3-2.3-1.6-3.7-1.4s-2,1.7-1.5,4.5s2.1,4.9,4.2,4.5
              c1.1-0.2,2.1-0.9,2.7-1.8L93.1,18.7z"/>
            <path d="M97.2,12.2c0.8,3,2.3,5.7,5,4.9c1.1-0.3,2.1-1,2.7-1.9l0.6,0.5c-0.8,1.6-2.2,2.8-3.9,3.4
              c-3.4,0.9-6.1-0.6-7.1-4.4c-0.9-3.3,0.8-6.8,3.8-7.6c2.5-0.7,5.1,0.7,5.8,3.2c0,0,0,0,0,0.1L97.2,12.2z M101,10
              c-0.4-1.5-1.4-2.3-2.6-2c-1.4,0.4-1.7,1.7-1.5,3.1L101,10z"/>
          </g>
          <g id="jodie" v-if="slider && characters[slider.currentIndex].id === 'jodie'" :key="slider.currentIndex">
            <path d="M22.3,27.1c2.5-0.8,3.5-2.3,3.9-5.5l1.6-14.3c0.2-1.6-0.3-2.3-2.4-2.5l0.1-1.1l9.1,1l-0.1,1.1
              c-2.1-0.2-2.7,0.3-2.9,1.9l-1.5,13.1c-0.5,4.1-3,6.4-8,7.2L22.3,27.1z"/>
            <path d="M40.8,24.6c-3.3-0.2-5.8-3-5.7-6.3c0-0.1,0-0.2,0-0.3c0.2-3.3,3.1-5.8,6.4-5.6c3.3,0.2,5.8,3.1,5.6,6.4
              c-0.1,3.3-2.8,5.9-6.2,5.8C40.9,24.6,40.9,24.6,40.8,24.6z M41.5,13.1c-1.6-0.1-2.7,1.9-2.9,5.1s0.7,5.3,2.3,5.4s2.7-1.9,2.9-5.1
              C44,15.3,43.2,13.2,41.5,13.1z"/>
            <path d="M58.8,25v-1.7C57.9,24.4,56.5,25,55,25c-3.1-0.1-5.6-2.7-5.5-5.8c0,0,0-0.1,0-0.1c0-3,2.2-6.6,6.1-6.6
              c1.1,0,2.2,0.3,3.1,1V8.3c0-1.3-0.2-1.6-1.2-1.9c-0.2-0.1-0.3-0.2-0.3-0.4s0-0.4,0.2-0.4c1.2-0.5,2.5-0.8,3.7-1.1
              c0.3,0,0.4,0.1,0.4,1.1l0.1,16.6c0,0.9,0.2,1.2,1,1.2c0.2,0,0.4,0,0.6-0.1v1L58.8,25z M56,13.7c-1.7,0-3.1,2.1-3,5.2
              c0,2.4,1.2,4.8,3,4.8c2.1,0,2.9-1.8,2.9-5C58.8,15.2,57.9,13.7,56,13.7z"/>
            <path d="M65.8,24.5l-0.1-1c1.4-0.1,1.8-0.4,1.7-1.8L67,16c-0.1-1.3-0.3-1.6-1.4-1.8c-0.1,0-0.2-0.2-0.2-0.4
              c0-0.3,0.1-0.4,0.3-0.5c1.1-0.5,2.3-0.9,3.5-1.3c0.3,0,0.5,0.1,0.6,1.1l0.6,8.6c0.1,1.3,0.5,1.5,1.9,1.4l0.1,1L65.8,24.5z
              M66.2,7.2c-0.1-1,0.6-1.8,1.6-1.9s1.8,0.6,1.9,1.6c0,0,0,0.1,0,0.1c0.1,1-0.7,1.8-1.6,1.9C67.1,8.9,66.3,8.2,66.2,7.2
              C66.2,7.3,66.2,7.2,66.2,7.2z"/>
            <path d="M77.2,16c0.3,3.1,1.5,5.9,4.3,5.6c1.1-0.1,2.2-0.7,2.9-1.5l0.5,0.5c-1,1.5-2.6,2.5-4.4,2.8
              c-3.5,0.4-5.9-1.5-6.4-5.3c-0.4-3.4,1.7-6.6,4.8-7c2.6-0.4,5,1.4,5.3,4c0,0,0,0,0,0L77.2,16z M81.2,14.4c-0.2-1.6-1-2.5-2.3-2.3
              c-1.4,0.2-1.9,1.5-1.9,2.8L81.2,14.4z"/>
          </g>
          <g id="susie" v-if="slider && characters[slider.currentIndex].id === 'susie'" :key="slider.currentIndex">
            <path d="M35.9,9.4c-0.1,0.6-0.2,0.7-0.6,0.7c-0.4,0-0.4-0.2-0.7-1c-0.6-1.7-2-3-3.8-3.3c-1.6-0.3-3.2,0.8-3.5,2.4
              c0,0,0,0,0,0.1c-0.4,4.2,9.3,4.1,8.6,10.6c-0.3,2.6-2,5.6-7.6,5.1c-1.8-0.2-3.5-0.8-5.1-1.7c-0.2-1.3-0.2-2.6-0.1-3.9
              c0.1-0.6,0.2-0.8,0.7-0.8c0.5,0.1,0.6,0.1,0.8,0.9c0.3,2.3,2.1,4.1,4.5,4.4c1.9,0.2,3.7-0.6,3.9-2.6c0.4-4.4-9.2-4.9-8.6-10.8
              c0.4-3.7,4.1-5.1,7-4.8c1.7,0.1,3.3,0.6,4.8,1.6c0,0.7,0,1.3-0.1,2L35.9,9.4z"/>
            <path d="M47.2,25.3l0.1-1.9c-1.2,1.1-2.7,1.7-4.3,1.8c-2.1-0.1-3.2-1.3-3.1-3.6l0.2-6.2c0-1.1-0.2-1.4-1.7-1.6v-1
              l4.8,0l-0.3,8.6c-0.1,1.6,0.4,2.3,1.5,2.3c0.9,0,1.7-0.4,3-1.4l0.2-5.8c0.1-1.9-0.3-2.2-2.1-2.5v-1l5.2-0.1l-0.3,9.5
              c0,1,0.3,1.4,1.7,1.4v1L47.2,25.3z"/>
            <path d="M61.8,15.7c0,0.2-0.1,0.4-0.4,0.4c-0.3,0-0.5-0.1-0.9-0.9c-0.5-0.8-1.4-1.4-2.3-1.4c-0.7,0-1.4,0.6-1.4,1.3
              c0,0,0,0,0,0.1c0.1,2.3,5.8,2.6,5.9,6.3c0.1,2.2-2.1,3.7-4.5,3.8c-0.7,0-3.7-0.3-3.7-1.3c0-0.5,0-2.4,0.8-2.4c1,0,0.9,2.8,3.3,2.7
              c0.9,0,1.6-0.5,1.6-1.5c-0.1-2.7-5.6-2.6-5.7-6.4c-0.1-2.1,1.7-3.6,4.6-3.6c1.8-0.1,2.7,0.5,2.8,0.9L61.8,15.7z"/>
            <path d="M65,24.8l-0.1-1c1.4-0.1,1.8-0.4,1.7-1.8l-0.4-5.8c-0.1-1.3-0.3-1.6-1.4-1.8c-0.1,0-0.2-0.2-0.2-0.4
              c0-0.3,0.1-0.4,0.3-0.5c1.1-0.5,2.3-0.9,3.5-1.3c0.3,0,0.5,0.1,0.6,1.1l0.6,8.6c0.1,1.3,0.5,1.5,1.9,1.4l0.1,1L65,24.8z M65.3,7.5
              c-0.1-1,0.7-1.8,1.6-1.9c1-0.1,1.8,0.7,1.9,1.6c0.1,1-0.7,1.8-1.6,1.9C66.2,9.2,65.4,8.5,65.3,7.5C65.3,7.5,65.3,7.5,65.3,7.5
              L65.3,7.5z"/>
            <path d="M76.3,16.2c0.3,3.1,1.5,5.9,4.3,5.5c1.1-0.1,2.2-0.7,2.9-1.5l0.6,0.5c-1,1.5-2.6,2.5-4.3,2.8
              c-3.5,0.5-6-1.4-6.5-5.3c-0.5-3.4,1.6-6.6,4.8-7c2.6-0.4,5,1.4,5.3,3.9c0,0,0,0,0,0.1L76.3,16.2z M80.3,14.5
              c-0.2-1.6-1.1-2.5-2.3-2.3c-1.4,0.2-1.9,1.5-1.9,2.8L80.3,14.5z"/>
          </g>
        </transition>
      </svg>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import Slider from '@/scripts/Slider';
import audio from '@/scripts/audio';
import { isTouchDevice } from '@/scripts/utils';

export default {
  name: 'CharacterSelection',

  data() {
    return {
      slider: null,
      firstEnter: true,
      isTouchDevice: isTouchDevice(),
      characters: [
        {
          id: 'florence',
          name: '',
          img: '/img/characters/florence.png',
        },
        {
          id: 'jodie',
          name: '',
          img: '/img/characters/jodie.png',
        },
        {
          id: 'anjelica',
          name: '',
          img: '/img/characters/anjelica.png',
        },
        {
          id: 'susie',
          name: '',
          img: '/img/characters/susie.png',
        },
      ],
    };
  },

  mounted() {
    this.slider = new Slider(this.$el);
  },

  methods: {
    enterText(el, done) {
      const letters = [...el.querySelectorAll('path')];
      const tl = gsap.timeline({ onComplete: done, delay: this.firstEnter ? 1.8 : 0.1 });
      this.firstEnter = false;

      tl.fromTo(letters, {
        yPercent: 100,
        opacity: 0,
      }, {
        yPercent: 0,
        opacity: 1,
        stagger: 0.03,
        ease: 'bloom',
      });
    },
    leaveText(el, done) {
      const letters = [...el.querySelectorAll('path')];
      const tl = gsap.timeline({ onComplete: done });

      tl.fromTo(letters, {
        yPercent: 0,
        opacity: 1,
      }, {
        yPercent: -100,
        opacity: 0,
        stagger: 0.03,
        ease: 'bloom',
      });
    },
    startPlaying() {
      this.$store.commit('SET_INTRO_DONE', true);
      this.$store.commit('SET_PLAY_GAME', false);
      this.$store.commit('SET_GAME_LOADING', true);
      this.$sendEvent('Bloom!', `character_choice_${this.$store.state.characterId}`);
      this.$game.setUpGame().then(() => {
        this.$store.commit('SET_GAME_LOADING', false);
        this.$game.startPlaying().then(() => {
          audio.stop('background-intro');
          this.$eventHub.$emit('play-pause');
          if (this.$store.state.tutorial < 3) this.$store.commit('SET_TUTORIAL', 0);
          else this.$game.startSpawning();
        });
      });
    },
  },

  beforeDestroy() {
    this.slider.destroy();
  },
};
</script>

<style lang="scss" scoped>
.slider {
  position: relative;
  height: 40vh;
  width: calc((40vh * 3) / 4);

  opacity: 0.9;

  &.slider--app {
    margin-bottom: 20px;
  }

  &__container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    cursor: pointer;

    svg {
      display: block;
      opacity: 0;
      height: 100%;
      width: auto;
    }

    .slider__bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .slider__item {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 100%;

      display: flex;
      align-items: center;
      justify-content: center;

      pointer-events: none;

      img {
        height: 100%;
      }
    }
  }

  &__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    cursor: pointer;

    img {
      position: relative;
      width: 35px;
      height: auto;
    }

    &.slider__arrow--left {
      left: -45px;
    }

    &.slider__arrow--right {
      right: -45px;
    }
  }

  &__name {
    position: absolute;
    bottom: 0;
    transform: translateY(8%);

    .name__bg {
      position: relative;
      width: 50%;
      transform: translateY(10%);
    }

    .name__text {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 35%;
      transform: translateX(-50%) translateY(-12%);

      fill: $red;
    }
  }

  @include mq(ipadP, $and: $is-not-touch-device) {
    &__arrow {
      img {
        width: 40px;
      }

      &.slider__arrow--left {
        left: -65px;
      }

      &.slider__arrow--right {
        right: -65px;
      }
    }
  }

  @include mq($and: $is-not-touch-device) {
    height: 42vh;
    width: calc((42vh * 3) / 4);

    &__arrow {
      img {
        transition: transform 0.3s $bloom;
      }

      &.slider__arrow--left:hover img {
        transform: translateX(-5px);
      }

      &.slider__arrow--right:hover img {
        transform: translateX(5px);
      }
    }
  }

  @include mq(ipadL) {
    &__arrow {
      img {
        width: 40px;
      }

      &.slider__arrow--left {
        left: -185px;
      }

      &.slider__arrow--right {
        right: -185px;
      }
    }
  }

  @include mq(ipadL, $and: $is-portrait) {
    &__arrow {
      &.slider__arrow--left {
        left: -225px;
      }

      &.slider__arrow--right {
        right: -225px;
      }
    }
  }
}
</style>
